import React from 'react'

import { ZariContext } from '_zari/context'
import { Button, Col, Form, Modal, Portlet, Row, Table } from '_zari/core'

import * as CodigosTransaccionesConstant from 'constants/codigosTransacciones'
import { EstadosInventarioFisicoConstant, EstadosConteoActivoConstant } from 'constants/index'

import * as ActivosFijosInventariosService from 'services/activosFijosInventarios.service'

const portletBreadcrumbs = [{ name: 'Activos Fijos' }, { name: 'Inventarios Físicos' }, { name: 'Editar' }]

const EditarPage = ({ history, match }) => {
  const __zariContext = React.useContext(ZariContext)
  const idInventario = match.params.idInventario
  const [data, setData] = React.useState(null)
  const [comentarioEstado, setComentarioEstado] = React.useState('')
  const [conteoModal, setConteoModal] = React.useState(null)
  const [conteoValues, setConteoValues] = React.useState({ estadoConteo: '', observaciones: '', oficinaReal: '' })

  const cargar = React.useCallback(() => {
    ActivosFijosInventariosService.get(idInventario).then(({ data }) => setData(data))
  }, [idInventario])

  React.useEffect(() => {
    cargar()
  }, [cargar])

  const cambiarEstado = React.useCallback(
    async nuevoEstado => {
      try {
        await ActivosFijosInventariosService.cambiarEstado(idInventario, { nuevoEstado, comentario: comentarioEstado })
        __zariContext.snack('success', 'Estado actualizado')
        setComentarioEstado('')
        cargar()
      } catch (e) {
        __zariContext.snack('error', e?.data?.error || 'Error al cambiar estado')
      }
    },
    [idInventario, comentarioEstado, __zariContext, cargar]
  )

  const abrirConteo = detalle => {
    setConteoValues({
      estadoConteo: detalle.estadoConteo === EstadosConteoActivoConstant.PENDIENTE ? '' : detalle.estadoConteo,
      observaciones: detalle.observaciones || '',
      oficinaReal: detalle.oficinaReal || ''
    })
    setConteoModal(detalle)
  }

  const registrarConteo = async () => {
    if (!conteoValues.estadoConteo) {
      __zariContext.snack('error', 'Seleccione el estado de conteo')
      return
    }
    try {
      await ActivosFijosInventariosService.registrarConteo(idInventario, {
        _idActivoFijo: conteoModal._idActivoFijo,
        estadoConteo: conteoValues.estadoConteo,
        observaciones: conteoValues.observaciones,
        oficinaReal: conteoValues.oficinaReal
      })
      __zariContext.snack('success', 'Conteo registrado')
      setConteoModal(null)
      cargar()
    } catch (e) {
      __zariContext.snack('error', e?.data?.error || 'Error al registrar conteo')
    }
  }

  if (!data) return null
  if (data.error) return <div>{data.error}</div>

  const estadoInfo = EstadosInventarioFisicoConstant.__dictionary[data.estado]

  const transicionesBotones = {
    [EstadosInventarioFisicoConstant.BORRADOR]: [
      { label: 'Iniciar Conteo', to: EstadosInventarioFisicoConstant.EN_PROCESO, color: 'primary' },
      { label: 'Anular', to: EstadosInventarioFisicoConstant.ANULADO, color: 'danger' }
    ],
    [EstadosInventarioFisicoConstant.EN_PROCESO]: [
      { label: 'Finalizar Conteo', to: EstadosInventarioFisicoConstant.FINALIZADO, color: 'primary' },
      { label: 'Anular', to: EstadosInventarioFisicoConstant.ANULADO, color: 'danger' }
    ],
    [EstadosInventarioFisicoConstant.FINALIZADO]: [
      { label: 'Conciliar', to: EstadosInventarioFisicoConstant.CONCILIADO, color: 'success' },
      { label: 'Regresar a En Proceso', to: EstadosInventarioFisicoConstant.EN_PROCESO, color: 'secondary' }
    ]
  }

  const botones = transicionesBotones[data.estado] || []
  const puedeContar = data.estado === EstadosInventarioFisicoConstant.BORRADOR || data.estado === EstadosInventarioFisicoConstant.EN_PROCESO

  return (
    <Portlet>
      <Portlet.Header
        title={`Inventario ${data.codigo} - ${estadoInfo?.nombre || ''}`}
        breadcrumbs={portletBreadcrumbs}
        buttons={[
          { name: 'Volver', onClick: () => history.push(`/${CodigosTransaccionesConstant.ACTIVOSFIJOS_INVENTARIOS_LISTA}`) }
        ]}
      />
      <Portlet.Body>
        <Row>
          <Col md={6}>
            <Form.Group>
              <Form.Label text='TÍTULO' md={12} />
              <Col md={12}>
                <Form.InputText disabled defaultValue={data.titulo} />
              </Col>
            </Form.Group>
          </Col>
          <Col md={3}>
            <Form.Group>
              <Form.Label text='FECHA INICIO' md={12} />
              <Col md={12}>
                <Form.InputText disabled defaultValue={data.fechaInicio} />
              </Col>
            </Form.Group>
          </Col>
          <Col md={3}>
            <Form.Group>
              <Form.Label text='FECHA FIN' md={12} />
              <Col md={12}>
                <Form.InputText disabled defaultValue={data.fechaFin || '--'} />
              </Col>
            </Form.Group>
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <Form.Group>
              <Form.Label text='DESCRIPCIÓN' md={12} />
              <Col md={12}>
                <Form.InputText disabled defaultValue={data.descripcion} />
              </Col>
            </Form.Group>
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <h6>
              Resumen: Total {data.totalActivos || 0} / Encontrados {data.totalEncontrados || 0} / No Encontrados{' '}
              {data.totalNoEncontrados || 0} / Diferente Ubicación {data.totalDiferentesUbicacion || 0} / Dañados{' '}
              {data.totalDaniados || 0}
            </h6>
          </Col>
        </Row>

        {botones.length > 0 && (
          <Row>
            <Col md={12}>
              <Form.Group>
                <Form.Label text='COMENTARIO (opcional)' md={12} />
                <Col md={12}>
                  <Form.InputText value={comentarioEstado} onChange={e => setComentarioEstado(e.target.value)} />
                </Col>
              </Form.Group>
            </Col>
            <Col md={12} style={{ textAlign: 'right' }}>
              {botones.map(b => (
                <Button key={b.to} color={b.color} onClick={() => cambiarEstado(b.to)} style={{ marginLeft: '8px' }}>
                  {b.label}
                </Button>
              ))}
            </Col>
          </Row>
        )}

        <Row>
          <Col md={12}>
            <h5>Detalle de Conteo</h5>
            <Table
              useNest={true}
              headRows={[
                { label: 'CÓDIGO' },
                { label: 'DESCRIPCIÓN' },
                { label: 'OFICINA ESPERADA' },
                { label: 'OFICINA REAL' },
                { label: 'ESTADO CONTEO' },
                { label: 'FECHA CONTEO' },
                { label: 'OBSERVACIONES' },
                { label: '', width: 60 }
              ]}
              filas={data.detalles || []}
              rowTemplate={(row, k) => (
                <Table.Row key={k}>
                  <Table.Cell>{row.codigoActivoFijo || '--'}</Table.Cell>
                  <Table.Cell>{row.descripcionActivoFijo || '--'}</Table.Cell>
                  <Table.Cell>{row.oficinaEsperada || '--'}</Table.Cell>
                  <Table.Cell>{row.oficinaReal || '--'}</Table.Cell>
                  <Table.Cell>
                    {EstadosConteoActivoConstant.__dictionary[row.estadoConteo]?.nombre || '--'}
                  </Table.Cell>
                  <Table.Cell>{row.fechaConteo || '--'}</Table.Cell>
                  <Table.Cell>{row.observaciones || '--'}</Table.Cell>
                  <Table.Cell>
                    {puedeContar && (
                      <Button color='primary' size='sm' onClick={() => abrirConteo(row)}>
                        Contar
                      </Button>
                    )}
                  </Table.Cell>
                </Table.Row>
              )}
            />
          </Col>
        </Row>

        <Row>
          <Col md={12}>
            <h5>Trazabilidad</h5>
            <Table
              useNest={true}
              headRows={[
                { label: 'FECHA' },
                { label: 'ESTADO ANTERIOR' },
                { label: 'ESTADO NUEVO' },
                { label: 'USUARIO' },
                { label: 'COMENTARIO' }
              ]}
              filas={data.trazabilidad || []}
              rowTemplate={(row, k) => (
                <Table.Row key={k}>
                  <Table.Cell>{row.fecha || '--'}</Table.Cell>
                  <Table.Cell>
                    {EstadosInventarioFisicoConstant.__dictionary[row.estadoAnterior]?.nombre || '--'}
                  </Table.Cell>
                  <Table.Cell>
                    {EstadosInventarioFisicoConstant.__dictionary[row.estadoNuevo]?.nombre || '--'}
                  </Table.Cell>
                  <Table.Cell>{row.usuarioNombre || '--'}</Table.Cell>
                  <Table.Cell>{row.comentario || '--'}</Table.Cell>
                </Table.Row>
              )}
            />
          </Col>
        </Row>

        {conteoModal && (
          <Modal show={true} onHide={() => setConteoModal(null)} size='md'>
            <Modal.Header>Registrar Conteo - {conteoModal.codigoActivoFijo}</Modal.Header>
            <Modal.Body>
              <Row>
                <Col md={12}>
                  <Form.Group>
                    <Form.Label text='ACTIVO' md={12} />
                    <Col md={12}>
                      <Form.InputText disabled defaultValue={conteoModal.descripcionActivoFijo} />
                    </Col>
                  </Form.Group>
                </Col>
                <Col md={12}>
                  <Form.Group>
                    <Form.Label text='ESTADO' md={12} />
                    <Col md={12}>
                      <Form.Select
                        name='estadoConteo'
                        value={conteoValues.estadoConteo}
                        onChange={e => setConteoValues(v => ({ ...v, estadoConteo: e.target.value }))}
                      >
                        <option value=''>--SELECCIONAR--</option>
                        {EstadosConteoActivoConstant.__array
                          .filter(x => x.id !== EstadosConteoActivoConstant.PENDIENTE)
                          .map(x => (
                            <option key={x.id} value={x.id}>
                              {x.nombre}
                            </option>
                          ))}
                      </Form.Select>
                    </Col>
                  </Form.Group>
                </Col>
                <Col md={12}>
                  <Form.Group>
                    <Form.Label text='OFICINA REAL (si es diferente)' md={12} />
                    <Col md={12}>
                      <Form.InputText
                        value={conteoValues.oficinaReal}
                        onChange={e => setConteoValues(v => ({ ...v, oficinaReal: e.target.value }))}
                      />
                    </Col>
                  </Form.Group>
                </Col>
                <Col md={12}>
                  <Form.Group>
                    <Form.Label text='OBSERVACIONES' md={12} />
                    <Col md={12}>
                      <Form.InputText
                        value={conteoValues.observaciones}
                        onChange={e => setConteoValues(v => ({ ...v, observaciones: e.target.value }))}
                      />
                    </Col>
                  </Form.Group>
                </Col>
              </Row>
            </Modal.Body>
            <Modal.Footer>
              <Button color='secondary' onClick={() => setConteoModal(null)}>
                Cancelar
              </Button>
              <Button color='primary' onClick={registrarConteo}>
                Registrar
              </Button>
            </Modal.Footer>
          </Modal>
        )}
      </Portlet.Body>
    </Portlet>
  )
}

export default React.memo(EditarPage)
